import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { ApiBaseResponse } from "models/ApiBaseResponse";
import { AxiosRequestConfig } from "axios";
import { GlobalOperations } from "config/GlobalApiOperations";
import { getToken, removeToken } from "@stores/authStore";

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  showToastOnError?: boolean;
}
// TODO: Error text silinecek bu işlem yalnızca ui kısmında kullanılacak
// Yardımcı fonksiyon: data.text varsa döner
const getErrorText = (data: ApiBaseResponse<null>): string | null => {
  return data.text;
};

// Merkezi API istemcisi
const api = axios.create({
  baseURL: GlobalOperations.BaseUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  validateStatus: (status) => {
    return (status >= 200 && status < 300) || status === 306;
  },
});

// İstek interceptor'ı
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Yanıt interceptor'ı
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<ApiBaseResponse<null>>) => {
    const config = error.config as CustomAxiosRequestConfig;

    const showToast = config?.showToastOnError !== false; // default true
    const { status, data } = error.response || {};
    const errorText = getErrorText(data as ApiBaseResponse<null>);

    if (status) {
      switch (status) {
        case 400:
          console.error("400 - Geçersiz İstek!");
          showToast && toast.error(errorText ?? "Geçersiz istek yaptınız.");
          break;
        case 401:
          console.error("401 - Yetkisiz Erişim!");
          removeToken();
          showToast && toast.error(errorText ?? "Yetkiniz yok. Giriş yapın.");
          // if (window.location.pathname !== "/tr-TR/Login") {
          //   showToast && toast.error(errorText ?? "Yetkiniz yok. Giriş yapın.");
          //   setTimeout(() => {
          //     window.location.href = "/tr-TR/Login";
          //   }, 1000);
          // }
          break;
        case 403:
          console.error("403 - Erişim Engellendi!");
          showToast && toast.error(errorText ?? "Bu işlemi yapmaya yetkiniz yok.");
          break;
        case 404:
          console.error("404 - Method Bulunamadı!");
          showToast && toast.error(errorText ?? "Aradığınız içerik bulunamadı.");
          break;
        case 500:
          console.error("500 - Sunucu Hatası!");
          showToast && toast.error(errorText ?? "Sunucu hatası oluştu. Daha sonra tekrar deneyin.");
          break;
        default:
          console.error(`${status} - Bilinmeyen Hata`);
          showToast && toast.error(errorText ?? "Bilinmeyen bir hata oluştu.");
      }
    } else {
      console.error("Bağlantı hatası:", error.message);
      showToast && toast.error("Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edin.");
    }

    return Promise.reject(error);
  }
);

export default api;
